"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastPlayIdsService = void 0;
const api_1 = require("./api");
const PATH = 'game/api';
class FastPlayIdsService {
    static async fetchFastPlayIds(gameTypeId) {
        const url = `${PATH}/game-by-gametype/${gameTypeId}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.FastPlayIdsService = FastPlayIdsService;
//# sourceMappingURL=fast-play-ids.js.map